import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import type { ViewCreateInput } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/views
//
// Pessimistic — the server assigns `position = max + 1` and `created_by =
// session.userId`. Optimism would mean either guessing the position
// (drifts against concurrent saves) or synthesizing a tab without an id
// (breaks the SavedViewTabs URL flow). The first list refetch arrives
// well under a second.

type CreateViewResponse = { id: string };

export function useCreateView() {
  const queryClient = useQueryClient();
  return useMutation<CreateViewResponse, ApiClientError, ViewCreateInput>({
    mutationFn: (input) =>
      apiFetch<CreateViewResponse>("/admin/views", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: (_data, input) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.views.list(input.entity_type),
      });
      toast.success("View saved");
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to save view");
    },
  });
}
